// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"49a3842d","844":"94adde89"}[chunkId] + ".chunk.css";
};